<template>
  <div>
    <div class="table-header">
      <h3>
        {{ title }}
        <span v-if="dropdown"
            class="table-header-btns">
          <el-dropdown @command="addRowCommand">
            <el-button size="small">
              行追加
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                  v-for="l in dropdownList"
                  :key="l.label"
                  :v-if="l.funcId == null || $isFunctionShown(l.funcId)"
                  :disabled="(l.funcId == null || $isFunctionDisabled(l.funcId)) ||
                    (typeof l.disabledCondition === 'function' ? l.disabledCondition(l.funcId) : false) ||
                    editableCondition(l.command)"
                  :command="l.command">
                {{ l.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </h3>
    </div>
    <table class="order-detail-items">
      <template>
        <colgroup>
          <col v-for="(col, index) in headerList"
              :key="index"
              :style="getColStyle(col)"
              :span="col.colspan">
        </colgroup>
        <tbody is="transition-group"
            class="item-detail-table-body"
            @before-enter="$_tableRowAnimator_beforeEnter"
            @before-leave="$_tableRowAnimator_beforeLeave"
            @enter="$_tableRowAnimator_enter"
            @leave="$_tableRowAnimator_leave">
          <tr key="header">
            <th v-for="(l, i) in headerList"
                :key="i"
                :colspan="l.colspan"
                :class="l.headerClass">
              {{ typeof l.label==="function" ? l.label() : l.label }}
            </th>
          </tr>
          <template v-if="type === 'total'">
            <!-- 小計値引 -->
            <template v-for="priceAdjustment in filteredMerchandisePriceAdjustments">
              <OrderDetailItemsRow
                  :key="getUuid(priceAdjustment) + 'adjustment'"
                  :parent="orderDetail"
                  :origin-data="originData"
                  :mode="mode"
                  :type="type"
                  :row="priceAdjustment"
                  :rows="orderDetail.merchandisePriceAdjustments"
                  :show-tooltip="orderAdjustToolTip"
                  row-type="adjustment"
                  :class="clickableClass('adjustment')"
                  @rowClick="onRowClick"
                  @requestCalculate="requestCalculate" />
            </template>
          </template>
          <template v-else>
            <template v-for="orderItemTypes in orderItemTypesUnit">
              <template v-for="orderItemType in orderItemTypes.orderItemTypes">
                <template v-for="orderItem in filteredItems(orderItemType)">
                  <OrderDetailItemsRow
                      :key="getUuid(orderItem)"
                      :parent="orderDetail"
                      :origin-data="originData"
                      :mode="mode"
                      :type="type"
                      :row="orderItem"
                      :rows="orderDetail[orderItemType]"
                      :row-type="orderItemType"
                      :show-tooltip="itemToolTip"
                      :show-component="componentOpenState(orderItem.id)"
                      :need-anbun-check.sync="needAnbunCheck"
                      :class="clickableClass(orderItemType)"
                      @changeComponentOpenState="changeComponentOpenState"
                      @rowClick="onRowClick"
                      @removeAnbun="removeAnbun"
                      @requestCalculate="requestCalculate" />
                  <template v-if="componentOpenState(orderItem.id)">
                    <!-- 構成品 -->
                    <template v-for="component in itemCompnents(orderItem)">
                      <OrderDetailItemsRow
                          :key="getUuid(component)"
                          :parent="orderDetail"
                          :origin-data="originData"
                          :mode="mode"
                          :type="type"
                          :row="component"
                          :parent-row="orderItem"
                          :rows="itemCompnents(orderItem)"
                          :row-type="'components'"
                          :show-tooltip="itemToolTip"
                          :class="clickableClass(orderItemType)"
                          @rowClick="onRowClick"
                          @requestCalculate="requestCalculate" />
                    </template>
                  </template>
                  <!-- 単品値引 -->
                  <template v-for="priceAdjustment in filteredItemPriceAdjustments(orderItem)">
                    <OrderDetailItemsRow
                        :key="getUuid(priceAdjustment)"
                        :parent="orderDetail"
                        :origin-data="originData"
                        :mode="mode"
                        :type="type"
                        :row="priceAdjustment"
                        :rows="orderItem.priceAdjustments"
                        :show-tooltip="adjustToolTip"
                        :row-type="rowItemAdjustmentType(orderItemType)"
                        :class="clickableClass(rowItemAdjustmentType(orderItemType))"
                        @rowClick="onRowClick"
                        @requestCalculate="requestCalculate" />
                  </template>
                </template>
              </template>
              <!-- 小計 -->
              <tr v-for="l in orderItemTypes.totalItemList"
                  :key="getUuid(l)"
                  :class="l.class">
                <td v-for="p in l.properties"
                    :key="getUuid(p)"
                    :colspan="p.colspan"
                    :class="p.class">
                  <BaseCell
                      :properties="p"
                      :display-item="orderDetail" />
                </td>
              </tr>
            </template>
          </template>
          <!-- 総合計 -->
          <template v-for="l in totalOrderList">
            <tr v-if="l.show == null || (typeof l.show === 'function' ? l.show() : l.show)"
                :key="getUuid(l)"
                :class="l.class">
              <template v-for="p in l.properties">
                <td v-show="p.show == null || p.show"
                    :key="getUuid(p)"
                    :colspan="p.colspan"
                    :class="p.class">
                  <BaseCell
                      :properties="p"
                      :display-item="orderDetail" />
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </template>
    </table>

    <BaseDialog
        title="注文明細"
        :visible.sync="orderItemDialogVisible"
        :before-close="onBeforeCloseOrderItemDialog"
        :show-only-close-button="showOnlyCloseButton(orderItemDetailCopy)"
        @closed="orderItemDialogClose"
        @cancel="orderItemDialogCancel"
        @ok="orderItemDialogOK">
      <template slot="contents">
        <OrderItem
            v-if="orderItemDialogVisible"
            :mode="mode"
            :display-type="orderItemDialogType"
            :target="orderItemDetailCopy"
            :parent="orderItemDetailParent"
            :order-items="orderItems"
            :order-detail="orderDetail"
            :order-detail-origin="originData"
            :order-adjustments="orderAdjustmentsCopy"
            :read-only="readOnlyOrderItem"
            validate-scope="orderItem" />
      </template>
      <template slot="prependFooter">
        <el-button
            v-if="showQtyDetail"
            class="show-qty-detail-btn"
            @click="showQtyDetailModal">
          数量明細
        </el-button>
        <AttributeButton
            v-if="showAttributeButton"
            class="attribute-button"
            :site-code="siteCode"
            :editable="editableAttribute"
            :attribute-values="attributes"
            :append-to-body="true"
            size=""
            page-name="order_detail"
            :area-name="attributeAreaName" />
      </template>
    </BaseDialog>
    <BaseDialog
        title="数量明細"
        width="35%"
        :visible.sync="qtyDetailDialogVisible"
        :show-footer="false">
      <template slot="contents">
        <QuantityDetail
            type="orderItem"
            :quantity="qtyDetailForDialog" />
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>
.order-detail-items {
  table-layout: fixed;
}
.clickable {
  cursor: pointer;
}
.show-qty-detail-btn {
  float: left;
}
.attribute-button {
  float: left;
  padding-left: 15px;
  }
</style>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import compare from '@/utils/compareUtils'
import math from '@/utils/math'
import { v4 as uuid } from 'uuid';
import * as define from '@/define'
import * as config from '@/config'

import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'
import tableRowAnimator from '@/components/mixins/tableRowAnimator'
import OrderDetailItemsRow from '@/components/pages/order/OrderDetailItemsRow'
import OrderItem from '@/components/pages/order/OrderItem'
import QuantityDetail from '@/components/pages/order/QuantityDetail'

import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseDialog from '@/components/molecules/BaseDialog'

import AttributeButton from '@/components/organisms/AttributeButton'

const PRODUCT_CATEGORY = Object.freeze(
  {
    PHYSICAL: 0,              // フィジカルのみ
    DIGITAL: 1,               // デジタルのみ
    MIXED: 2                  // 混在
  }
)

export default {
  name: 'OrderDetailItems',
  components: {
    BaseCell,
    OrderDetailItemsRow,
    OrderItem,
    QuantityDetail,
    BaseDialog,
    AttributeButton
  },
  mixins: [x, orderUtil, tableRowAnimator],
  inject: ['parentValidator'],
  props: {
    title: {
      type: String,
      default: ''
    },
    orderDetail: {
      type: Object,
      default: () => ({})
    },
    originData: {
      type: Object,
      default: () => ({})
    },
    orderAdjustments: {
      type: Array,
      default: () => []
    },
    mode: {
      type: Number,
      default: define.ORDER_MODE.NORMAL
    },
    type: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'origin', 'total'].indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      // 数量情報行開閉
      qtyDetailIndex: [],
      orderItemDialogVisible: false,
      orderItemDialogForNewRecord: false,
      orderItemDialogPrev: null,
      orderItemDialogType: '',
      orderItemDetail: {},
      orderItemDetailCopy: null,
      orderAdjustmentsCopy: _.cloneDeep(this.orderAdjustments),
      orderItemDetailParent: null,
      qtyDetailDialogVisible: false,
      qtyDetailForDialog: {},
      needAnbunCheck: false
    }
  },
  computed: {
    define: () => define,
    ...mapGetters({
      getServiceSiteConfig: 'getServiceSiteConfig',
      wrappingCharge: 'wrappingCharge',
      shippingCharge: 'shippingCharge',
      codFee: 'codFee',
      cvsFee: 'cvsFee',
      getPointAdjustmentConfig: 'getPointAdjustmentConfig',
      getAnbunSelectTarget: 'getAnbunSelectTarget'
    }),
    ...mapGetters('OrderDetail', {
      siteCode: 'siteCode',
      taxInfo: 'taxInfo',
      orderDetailF: 'orderDetail',
      componentOpenState: 'componentOpenState'
    }),
    modalTableList () {
      return ''
    },
    headerList () {
      return this.type === 'total' ? [
        { label: '', width: 0, colspan: 1 },
        { label: '', width: 100, colspan: 1 },
        {
          label: () => {
            return _.chain(this.orderDetail)
              .get('merchandisePriceAdjustments')
              .filter(val => val.delete !== 1)
              .size()
              .thru(val => val > 0 ? '表示名称' : '')
              .value()
          }, colspan: 14
        },
        { label: '', colspan: 5 },
        { label: '金額', headerClass: 'right', width: 160, colspan: 3 },
        { label: '', width: 45, colspan: 1 }
      ] : [
        { label: '', width: 35, colspan: 1 },
        { label: 'No', width: 25, colspan: 1 },
        { label: '', width: 50, colspan: 2 },
        { label: '', width: 150, colspan: 3 },
        { label: '', width: 100, colspan: 1 },
        { label: 'SKU', width: 180, colspan: 2 },
        { label: '商品名', colspan: 1 },
        { label: '', width: 20, colspan: 1 },
        { label: '', width: 90, colspan: 1 },
        { label: '', colspan: 1 },
        { label: '売価', headerClass: 'right', width: 100, colspan: 3 },
        { label: '数量', headerClass: 'right', width: 60, colspan: 3 },
        { label: '金額', headerClass: 'right', width: 100, colspan: 3 },
        { label: '', width: 45, colspan: 1 }
      ]
    },
    dropdown () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) &&
        ['normal', 'total'].includes(this.type) && this.dropdownList.length > 0
    },
    itemToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'normal'
    },
    componentToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'normal'
    },
    adjustToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'normal'
    },
    orderAdjustToolTip () {
      return ![define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode) && this.type === 'total'
    },
    showQtyDetail () {
      return [ 'item', 'component' ].includes(this.orderItemDialogType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.QUANTITY_DETAIL)
    },
    showAttributeButton () {
      return [ 'item', 'component' ].includes(this.orderItemDialogType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.ATTRIBUTE)
    },
    filteredMerchandisePriceAdjustments () {
      return _.filter(this.orderDetail.merchandisePriceAdjustments, val => val.delete !== 1)
    },
    totalOrderList () {
      return this.type === 'total'
        ? [
          {
            key: '-orderTotal',
            properties: [
              { path: null, colspan: 16 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '総合計(税込)',
                colspan: 5, class: { bold: true, right: true, 'border-top': true }
              },
              {
                type: 'Number', path: 'orderTotalPrice.gross', colspan: 3,
                class: { bold: true, right: true, 'border-top': true }
              },
              { path: null, class: { 'border-top': true } }
            ]
          },
          {
            key: '-orderTotalTax', show: this.showTotalTax,
            properties: [
              { path: null, colspan: 16 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '(内消費税)',
                colspan: 5, class: { bold: true, right: true }
              },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                path: (row) => {
                  return math.subtract(
                    [
                      _.get(this.orderDetail, 'orderTotalPrice.gross', 0),
                      _.get(this.orderDetail, 'orderTotalPrice.net', 0)
                    ],
                    config.ORDER_CONFIG.price.roundType,
                    config.ORDER_CONFIG.price.decimalDigit)
                }, colspan: 3, class: { bold: true, right: true }
              },
              { path: null }
            ]
          }
        ]
        : [
          {
            key: '-shipmentTotal',
            properties: [
              { path: null, colspan: 13 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '配送合計(税込)',
                colspan: 4, class: { bold: true, right: true, 'border-top': true }
              },
              { path: null, colspan: 3, class: { 'border-top': true } },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                colspan: 3, class: { bold: true, right: true, 'border-top': true },
                path: () => {
                  const gross = _.chain(this.orderDetail)
                    .thru(val => _.concat([], val.items, val.giftItems, val.shippingItems, val.adjustmentItems))
                    .filter(val => val != null && val.delete !== 1)
                    .flatMap(val => _.concat([], val, val.priceAdjustments))
                    .filter(val => val != null && val.delete !== 1)
                    .map('price.gross')
                    .value()
                  return math.add(gross)
                }
              },
              { path: null, class: { 'border-top': true } }
            ]
          },
          {
            key: '-shipmentPhysicalTotal',
            properties: [
              { path: null, colspan: 13 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '【内訳】フィジカル合計(税込)',
                colspan: 4, class: { bold: true, right: true, 'border-top': true }
              },
              { path: null, colspan: 3, class: { 'border-top': true } },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                colspan: 3, class: { bold: true, right: true, 'border-top': true },
                path: () => { return this.shipmentPhysicalTotal() }
              },
              { path: null, class: { 'border-top': true } }
            ]
          },
          {
            key: '-shipmentDigitalTotal',
            properties: [
              { path: null, colspan: 13 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '【内訳】デジタル合計(税込)',
                colspan: 4, class: { bold: true, right: true, 'border-top': true }
              },
              { path: null, colspan: 3, class: { 'border-top': true } },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                colspan: 3, class: { bold: true, right: true, 'border-top': true },
                path: () => { return this.shipmentDigitalTotal() }
              },
              { path: null, class: { 'border-top': true } }
            ]
          }
        ]
    },
    orderItemTypesUnit () {
      if (this.type === 'total') {
        return []
      }
      let item = {
        key: 'item',
        orderItemTypes: ['items']
      }
      let itemType = []
      if (this.type === 'received') {
        itemType.push(item)
      } else {
        item.totalItemList = [
          {
            key: '-merchandiseTotal', class: { 'orderdetail-line': true },
            properties: [
              { path: null, colspan: 14 },
              {
                type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '小計(税込)',
                colspan: 3, class: { bold: true, right: true }
              },
              { type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                path: (row) => {
                  return math.add(
                    _.map(this.orderDetail.items, 'qty.current'),
                    config.ORDER_CONFIG.price.roundType,
                    config.ORDER_CONFIG.price.decimalDigit)
                }, colspan: 3, class: { bold: true, right: true } },
              {
                type: 'Number', elementType: ELEMENT_TYPE.FUNCTION,
                path: (row) => {
                  return math.add(
                    _.concat([],
                      _.map(this.orderDetail.items, 'price.gross'),
                      _.chain(this.orderDetail.items)
                        .flatMap(val => val.priceAdjustments)
                        .filter(val => val.delete !== 1)
                        .map('price.gross')
                        .filter(val => val != null)
                        .value()
                    ),
                    config.ORDER_CONFIG.price.roundType,
                    config.ORDER_CONFIG.price.decimalDigit)
                }, colspan: 3, class: { bold: true, right: true }
              },
              { path: null }
            ]
          }
        ]

        itemType.push(
          item,
          {
            key: 'gift',
            orderItemTypes: ['giftItems']
          },
          {
            key: 'shipping',
            orderItemTypes: ['shippingItems']
          },
          {
            key: 'adjustment',
            orderItemTypes: ['adjustmentItems']
          })
      }
      return itemType
    },
    dropdownList () {
      const dropdownList = this.type === 'total' ? [
        // { label: '小計後値引', command: 'merchandisePriceAdjustments',
        //   funcId: define.PermissionKeys.Order.Detail.OrderInfo.TotalDetail.MERCHANDISE_PRICE_ADJUSTMENTS },
        // { label: 'ポイント値引', command: 'pointPriceAdjustment',
        //   funcId: define.PermissionKeys.Order.Detail.OrderInfo.TotalDetail.POINT_PRICE_ADJUSTMENTS }
      ] : [
        { label: 'ギフト', command: 'giftItems',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.GIFT },
        { label: '送料', command: 'shippingItems',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.SHIPPING },
        { label: '代金引換手数料', command: 'codFeeItems',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.COD_FEE },
        { label: 'コンビニエンスストア決済手数料', command: 'cvsFeeItems',
          funcId: define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.CVS_FEE }
      ]
      return dropdownList.filter((element) => { return element.funcId == null || this.$isFunctionShown(element.funcId) })
    },
    cancelAnimation () {
      return this.mode === define.ORDER_MODE.NORMAL
    },
    orderItems () {
      return _.pick(this.orderDetail, ['items'])
    },
    readOnlyOrderItem () {
      return !['normal', 'total'].includes(this.type)
    },
    editableAttribute () {
      return !this.$isFunctionDisabled(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.ProductDetail.Attribute.ATTRIBUTE_EDIT) &&
        this.type === 'normal' &&
        [define.ORDER_MODE.EDIT, define.ORDER_MODE.SHORTAGE, define.ORDER_MODE.EXCHANGE].includes(this.mode)
    },
    attributes () {
      return _.get(this.orderItemDetailCopy, 'attributes', [])
    },
    attributeAreaName () {
      return this.orderItemDialogType === 'component' ? 'order_bundle_item' : 'order_item'
    }
  },
  watch: {
    cancelAnimation () {
      this.$_tableRowAnimator_cancelAnimation = this.cancelAnimation
    },
    orderAdjustments: {
      handler: function (val, oldVal) {
        this.orderAdjustmentsCopy = _.cloneDeep(this.orderAdjustments)
      },
      deep: true
    }
  },
  created () {
    this.$validator = this.parentValidator
  },
  mounted () {
    this.$_tableRowAnimator_cancelAnimation = this.cancelAnimation
  },
  methods: {
    ...mapActions('OrderDetail', [
      'calculateTotal',
      'manageComponentOpenState'
    ]),
    filteredItems (orderItemType) {
      return _.filter(this.orderDetail[orderItemType], val => val.delete !== 1)
    },
    itemCompnents (item) {
      return item.bundleItems || []
    },
    filteredItemPriceAdjustments (items) {
      return _.filter(items.priceAdjustments, val => val.delete !== 1)
    },
    showTotalTax () {
      return this.mode === define.ORDER_MODE.NORMAL
    },
    createEmptyOtherItem (config) {
      return config == null ? {} : {
        lineitemText: config.lineitemText,
        basePrice: { net: 0, gross: 0 },
        price: { net: 0, gross: 0 },
        taxRate: math.divide([_.get(this.taxInfo, 'rate', 0), 100]),
        productId: config.productId,
        shipment: { id: null }
      }
    },
    createEmptyGiftItem () {
      const config = this.wrappingCharge(this.siteCode)
      const item = this.createEmptyOtherItem(config)
      item.productName = config.productName
      return item
    },
    createEmptyShippingItem () {
      return this.createEmptyOtherItem(this.shippingCharge(this.siteCode))
    },
    createEmptyCodFeeItem () {
      return this.createEmptyOtherItem(this.codFee(this.siteCode))
    },
    createEmptyCvsFeeItem () {
      return this.createEmptyOtherItem(this.cvsFee(this.siteCode))
    },
    createEmptyPriceAdjustment () {
      return {
        promotionId: '',
        campaignId: '',
        couponId: '',
        reasonCode: '',
        lineitemText: '',
        basePrice: { net: 0, gross: 0 },
        price: { net: 0, gross: 0 },
        priceAdjustmentItems: []
      }
    },
    createEmptyPointPriceAdjustment () {
      // プロモーションID
      const promotionId = this.getPointAdjustmentConfig(this.siteCode, 'promotion_id')
      // キャンペーンID
      const campaignId = this.getPointAdjustmentConfig(this.siteCode, 'campaign_id')
      // クーポンID
      const couponId = this.getPointAdjustmentConfig(this.siteCode, 'coupon_id')
      // 表示名称
      const lineitemText = this.getPointAdjustmentConfig(this.siteCode, 'lineitem_text')
      return {
        promotionId: promotionId || '', // プロモーションID
        campaignId: campaignId || '', // キャンペーンID
        couponId: couponId || '', // クーポンID
        reasonCode: '', // 理由コード
        lineitemText: lineitemText || '', // 表示名称
        basePrice: { net: 0, gross: 0 }, // 調整単価
        price: { net: 0, gross: 0 }, // 調整金額
        isPoint: 1, // ポイントフラグ
        priceAdjustmentItems: []
      }
    },
    getUuid (obj) {
      if (!obj.orderDetailItemsKey) {
        obj.orderDetailItemsKey = uuid()
      }
      return obj.orderDetailItemsKey
    },
    /**
     * 商品行、注文値引行追加(ドロップダウン)
     * @param {String} itemType 明細タイプ
     */
    addRowCommand: function (itemType) {
      let addModel = {}
      switch (itemType) {
        case 'shippingItems':
          addModel = this.createEmptyShippingItem()
          break
        case 'codFeeItems':
          addModel = this.createEmptyCodFeeItem()
          // 手数料の場合、itemType を差し替え
          addModel.isCodFee = true
          itemType = 'shippingItems'
          break
        case 'cvsFeeItems':
          addModel = this.createEmptyCvsFeeItem()
          // 手数料の場合、itemType を差し替え
          addModel.isCvsFee = true
          itemType = 'shippingItems'
          break
        case 'giftItems':
          addModel = this.createEmptyGiftItem()
          break
        case 'merchandisePriceAdjustments':
          addModel = this.createEmptyPriceAdjustment()
          break
        case 'pointPriceAdjustment':
          addModel = this.createEmptyPointPriceAdjustment()
          itemType = 'merchandisePriceAdjustments'
          break
        default:
          return
      }
      this.orderItemDetail = _.cloneDeep(addModel)
      this.orderDetail[itemType].push(this.orderItemDetail)
      this.orderItemDetailCopy = _.cloneDeep(this.orderItemDetail)
      this.orderItemDialogVisible = true
      this.orderItemDialogForNewRecord = true
      switch (itemType) {
        case 'giftItems':
          this.orderItemDialogType = 'giftItem'
          break
        case 'shippingItems':
          this.orderItemDialogType = 'shippingItem'
          break
        case 'merchandisePriceAdjustments':
          this.orderItemDialogType = 'priceAdjustment'
          break
        default:
          break
      }
    },
    onBeforeCloseOrderItemDialog (done) {
      this.revertNewItem()
      done()
    },
    orderItemDialogCancel () {
      this.revertNewItem()
      this.orderItemDialogVisible = false
      this.needAnbunCheck = false
      this.orderAdjustmentsCopy = _.cloneDeep(this.orderAdjustments)
    },
    revertNewItem () {
      if (!this.orderItemDialogForNewRecord) {
        return
      }
      let list
      switch (this.orderItemDialogType) {
        case 'item':
          list = _.get(this.orderDetail, 'items', [])
          break
        case 'component':
          this.$set(this.orderItemDialogPrev.parent.bundleItems, this.orderItemDialogPrev.index, this.orderItemDialogPrev.item)
          this.orderItemDialogPrev.parent.bundleItems.pop()
          return
        case 'giftItem':
          list = _.get(this.orderDetail, 'giftItems', [])
          break
        case 'shippingItem':
          list = _.get(this.orderDetail, 'shippingItems', [])
          break
        case 'itemPriceAdjustment':
        case 'giftItemPriceAdjustment':
        case 'shippingItemPriceAdjustment':
          list = _.get(this.orderItemDetailParent, 'priceAdjustments', [])
          break
        case 'priceAdjustment':
          list = _.get(this.orderDetail, 'merchandisePriceAdjustments', [])
          break
        default:
          return
      }
      if (this.orderItemDialogPrev) {
        // 元データを復元
        this.$set(list, this.orderItemDialogPrev.index, this.orderItemDialogPrev.item)
      }
      // 追加されている行を削除
      const index = _.findIndex(list,
        val => val.orderDetailItemsKey === this.orderItemDetail.orderDetailItemsKey)
      if (index >= 0) {
        list.splice(index, 1)
      }

      this.calculateTotal()
    },
    async orderItemDialogOK () {
      let canClose = true
      if (['normal', 'total'].includes(this.type)) {
        canClose = await this.$validator.validate('orderItem.*')
      }
      if (canClose) {
        const diff = compare.diff(this.orderItemDetail, this.orderItemDetailCopy)
        _.merge(this.orderItemDetail, _.cloneDeep(this.orderItemDetailCopy))
        // 小計値引きの場合、按分リストに削除された対象がマージできないので、再設定する
        if (this.orderItemDialogType === 'priceAdjustment') {
          this.orderItemDetail.priceAdjustmentItems = this.orderItemDetailCopy.priceAdjustmentItems
        }
        if (this.orderItemDialogType === 'adjustmentItem') {
          _.merge(this.orderAdjustments, _.cloneDeep(this.orderAdjustmentsCopy))
        }
        if (diff != null) {
          this.calculateTotal()
          // 交換、振替の新規の場合、明細金額が０になるため、その際に按分対象除外処理は行わず、
          // 新規の保存するときに、按分対象除外処理をさせる
          if (this.needAnbunCheck && this.orderItemDetailCopy.exchanges.length > 0) {
            // 交換、振替された明細のUUIDをキー
            this.removeAnbun(this.orderItemDetailCopy.exchanges[0].srcOrderItem.uuid)
          }
        }
        this.orderItemDialogVisible = false
        this.needAnbunCheck = false
        // ■按分対象除外
        //  ●交換・振替時の新規行選択時に振替・交換先選択され、振替・交換元の明細の金額が0円、OKクリック時にフラグを立てる
        //    ※明細行のデータにフラグを持つのではなく、dataとかに持つ
        //  ●金額のwatch
        //    0円の時按分対象から除外
        //    上のフラグが立っていた場合処理を行わない
        //  ●注文明細OKクリック時
        //    上のフラグが立っていた場合、
        //    小計値引きの按分対象から振替・交換元を除外する処理を行い、フラグを落とし、按分対象から除外した旨のメッセージを表示
        //  ●注文明細キャンセル時、×時
        //    上のフラグが立っていた場合、フラグを落とす
      }
    },
    /**
     * 商品明細ダイアログの値を初期化する
     */
    orderItemDialogClose () {
      this.orderItemDetailCopy = null
      this.orderItemDetailParent = null
      this.orderItemDialogType = ''
      this.orderItemDialogForNewRecord = false
      this.orderItemDialogPrev = null
      this.needAnbunCheck = false
      this.orderAdjustmentsCopy = _.cloneDeep(this.orderAdjustments)
    },
    showQtyDetailModal: function () {
      this.qtyDetailForDialog = this.orderItemDetail.qty
      this.qtyDetailDialogVisible = true
    },
    disabledConditionAddRowDropDown: function () {
      if (this.mode === define.ORDER_MODE.EDIT) {
        return false
      }
      return true
    },
    /**
     * 数量計算
     */
    setCalculateCurrentQty (orderItem) {
      const qty = orderItem.qty
      qty.current = math.add([qty.ordered, -qty.canceled, -qty.inshipCanceled, -qty.transfer, -qty.receiveFixed, qty.exOut, qty.exOutExported, qty.exOutFixed, -qty.exIn, -qty.exInFixed])
      return orderItem
    },
    rowItemAdjustmentType (itemType) {
      switch (itemType) {
        case 'items':
          return 'itemAdjustment'
        case 'giftItems':
          return 'giftItemAdjustment'
        case 'shippingItems':
          return 'shippingItemAdjustment'
      }
    },
    onRowClick (event, row, rowType, isNewline, prev) {
      if (this.canClickRow(rowType)) {
        this.showDetailModal(row, rowType, isNewline, prev)
      }
    },
    changeComponentOpenState (row) {
      this.manageComponentOpenState(row.id)
      return ''
    },
    showDetailModal (rowItem, rowType, isNewline, prev) {
      switch (rowType) {
        case 'items':
          this.orderItemDialogType = 'item'
          break
        case 'components':
          this.orderItemDialogType = 'component'
          break
        case 'giftItems':
          this.orderItemDialogType = 'giftItem'
          break
        case 'shippingItems':
          this.orderItemDialogType = 'shippingItem'
          break
        case 'adjustmentItems':
          this.orderItemDialogType = 'adjustmentItem'
          break
        case 'itemAdjustment':
        case 'giftItemAdjustment':
        case 'shippingItemAdjustment':
          let type
          let parentList
          switch (rowType) {
            case 'itemAdjustment':
              type = 'itemPriceAdjustment'
              parentList = this.orderDetail.items
              break
            case 'giftItemAdjustment':
              type = 'giftItemPriceAdjustment'
              parentList = this.orderDetail.giftItems
              break
            case 'shippingItemAdjustment':
              type = 'shippingItemPriceAdjustment'
              parentList = this.orderDetail.shippingItems
              break
          }
          this.orderItemDialogType = type
          this.orderItemDetailParent = _.find(parentList, val => {
            return _.find(val.priceAdjustments,
              val => val.orderDetailItemsKey === rowItem.orderDetailItemsKey) != null
          })
          break
        case 'adjustment':
          this.orderItemDialogType = 'priceAdjustment'
          break
        default:
          return
      }
      this.orderItemDetail = rowItem
      this.orderItemDetailCopy = _.cloneDeep(rowItem)
      this.orderItemDialogVisible = true
      this.orderItemDialogForNewRecord = isNewline || false
      this.orderItemDialogPrev = prev
    },
    requestCalculate () {
      this.calculateTotal()
    },

    /**
     * ダイアログで閉じるボタンを表示するか判定する
     *  編集不可の場合、閉じるボタンのみの表示となる
     * @param {*} orderItem 注文明細行
     * @return {Booleam} 閉じるボタンの表示
     */
    showOnlyCloseButton (row) {

      // データがない場合、編集不可
      if (row == null) return true

      // // コンポーネントタイプが 通常、合計 以外の場合、編集不可
      // if (!['normal', 'total'].includes(this.type)) return true
      // コンポーネントタイプが 通常 以外の場合、編集不可
      if (!['normal'].includes(this.type)) return true

      // モードが 通常、配送先登録、手動決済、支払方法変更の場合、編集不可
      if ([define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT,
        define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(this.mode)) return true

      // 以外は OK 編集可のため、閉じるボタンは表示しない
      return false

    },

    getColStyle (col) {
      const style = {}
      if (col.width != null) {
        style.width = `${col.width / _.get(col, 'colspan', 1)}px`
      }
      return style
    },
    clickableClass (rowType) {
      if (this.canClickRow(rowType)) {
        return 'clickable'
      }
      return ''
    },
    canClickRow (rowType) {
      if ((rowType === 'adjustment' && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.TotalDetail.ADJUSTMENTS_DETAIL)) ||
        (['items', 'components'].includes(rowType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.PRODUCT_DETAIL)) ||
        (['shippingItems', 'giftItems', 'codFeeItems', 'cvsFeeItems', 'adjustmentItems'].includes(rowType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.FEE_DETAIL)) ||
        (['itemAdjustment', 'shippingItemAdjustment', 'giftItemAdjustment'].includes(rowType) && this.$isFunctionShown(define.PermissionKeys.Order.Detail.OrderInfo.ItemDetail.DISCOUNT_DETAIL))) {
        return true
      }
      return false
    },
    /** 編集可否条件 */
    editableCondition: function (command) {
      if (command === 'pointPriceAdjustment') {
        return _.chain(this.orderDetail)
          .get('merchandisePriceAdjustments')
          .filter(val => val.isPoint === 1 && val.delete !== 1)
          .size() > 0
      }
      return false
    },
    /** 交換、振替された明細を按分リストから除外する */
    removeAnbun: function (uuid) {
      const selectTarget = this.getAnbunSelectTarget(this.siteCode)
      if (selectTarget !== '1') {
        return
      }
      let hasAnbun = false
      for (const priceAdjustment of this.orderDetailF.merchandisePriceAdjustments) {
        // 削除済みの注文調整金額は対象外
        if (priceAdjustment.delete === 1) {
          continue
        }
        // 交換、振替された明細は按分対象に当たるか
        const idx = priceAdjustment.priceAdjustmentItems.findIndex(item => {
          if ((_.has(item, 'orderItemUuid') && item.orderItemUuid === uuid && item.delete === 0) ||
            (_.has(item, 'orderDetailItemsKey') && item.orderDetailItemsKey === uuid && item.delete === 0) ||
            (!_.has(item, 'orderItemUuid') && !_.has(item, 'orderDetailItemsKey') &&
              _.has(item, 'item') && item.item.uuid === uuid)) {
            return true
          }
          return false
        })
        // 按分対象に交換、振替された明細が入ってる場合、除外処理を行う
        if (idx >= 0) {
          const priceAdjustmentItem = priceAdjustment.priceAdjustmentItems[idx]
          // idがないと、画面から新規追加された按分対象なので、直接リストから除外
          if (!_.has(priceAdjustmentItem, 'id')) {
            priceAdjustment.priceAdjustmentItems.splice(idx, 1)
          } else {
            // idがある場合、削除情報を設定し、API側で削除処理を行う
            // 「orderDetailItemsKey」がある場合は必ず新規追加された按分対象なので、ここで判断対象外
            if (!_.has(priceAdjustmentItem, 'orderItemUuid') && _.has(priceAdjustmentItem, 'item')) {
              _.set(priceAdjustmentItem, 'orderItemUuid', priceAdjustmentItem.item.uuid)
            }
            _.set(priceAdjustmentItem, 'delete', 1)
          }
          hasAnbun = true
        }
      }
      // 除外された按分対象があれば、警告メッセージを出す
      if (hasAnbun) {
        this.$alert(
          '小計値引きの按分対象から除外されました。',
          define.MESSAGE_TITLE,
          { type: 'warning', showClose: false }
        )
      }
    },
    getPhysicalProductId () {
      return _.get(this.getServiceSiteConfig(this.siteCode, 'CCS_batch_order_import', 'product_id', 'physical'), 'v.0', '')
    },
    getDigitalProductId () {
      return _.get(this.getServiceSiteConfig(this.siteCode, 'CCS_batch_order_import', 'product_id', 'digital'), 'v.0', '')
    },
    getPhysicalItems () {

      // 通常商品(バンドルではない)
      const item = _.chain(this.orderDetail)
        .thru(val => _.concat([], val.items))
        .filter(val => (val.isBundle === 0) && (val.bundleItems.length === 0))
        .filter(val => val.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL) || val.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL_BONUS))
        .filter(val => val != null && val.delete !== 1)
        .flatMap(val => _.concat([], val, val.priceAdjustments))
        .filter(val => val != null && val.delete !== 1)
        .map('price.gross')
        .value()

      // バンドル構成品
      const bundleItems = _.chain(this.orderDetail)
        .thru(val => _.concat([], val.items))
        .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
        .filter(val => val != null && val.delete !== 1)
        .flatMap(val => _.concat([], val.bundleItems))
        .filter(val => val.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL) || val.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL_BONUS))
        .filter(val => val != null && val.delete !== 1)
        .value()
      let bundle = []
      for (const item of bundleItems) {
        const grossPrice = _.chain(item)
          .thru(val => _.concat([], val.attributes))
          .filter((val) => val.attrId === 'base-gross-price')
          .map('attrValue')
          .value() * item.qty.current
        bundle = _.concat([], bundle, grossPrice)
      }

      // バンドル構成品の調整金額
      let bundlePriceAdjustment = []
      for (const i in this.orderDetail.items) {
        // バンドル構成品のフィジカル存在確認
        const bundlePhysical = _.chain(this.orderDetail)
          .thru(val => _.concat([], val.items[i]))
          .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
          .filter(val => (val.bundleItems.some((x) => {
            return (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL_BONUS))
          })))
          .value()

        // バンドル構成品のデジタル存在確認
        const bundleDigital = _.chain(this.orderDetail)
          .thru(val => _.concat([], val.items[i]))
          .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
          .filter(val => (val.bundleItems.some((x) => {
            return (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_BONUS)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_MESSAGE_BONUS))
          })))
          .value()

        // バンドル構成品のフィジカル/デジタル種別チェック
        let productCategory
        if (bundlePhysical.length > 0 && bundleDigital.length > 0) {
          productCategory = PRODUCT_CATEGORY.MIXED
        } else if (bundleDigital.length > 0) {
          productCategory = PRODUCT_CATEGORY.DIGITAL
        } else { // (bundlePhysical.length > 0)
          productCategory = PRODUCT_CATEGORY.PHYSICAL
        }

        // バンドル構成品の調整金額(yell) ※混在の場合はデジタルに計上する
        let yell = []
        if (productCategory === PRODUCT_CATEGORY.PHYSICAL) {
          yell = _.chain(this.orderDetail)
            .thru(val => _.concat([], val.items[i]))
            .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
            .filter(val => (val.bundleItems.some((x) => {
              return (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL_BONUS))
            })))
            .filter(val => val != null && val.delete !== 1)
            .flatMap(val => _.concat([], val.priceAdjustments))
            .filter(val => val != null && val.delete !== 1)
            .filter(val => val.promotionId === 'yell')
            .map('price.gross')
            .value()
        }

        // バンドル構成品の調整金額 ※混在の場合はフィジカルに計上する
        let priceAdjustment = []
        if (productCategory === PRODUCT_CATEGORY.PHYSICAL || productCategory === PRODUCT_CATEGORY.MIXED) {
          priceAdjustment = _.chain(this.orderDetail)
            .thru(val => _.concat([], val.items[i]))
            .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
            .filter(val => (val.bundleItems.some((x) => {
              return (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL_BONUS))
            })))
            .filter(val => val != null && val.delete !== 1)
            .flatMap(val => _.concat([], val.priceAdjustments))
            .filter(val => val != null && val.delete !== 1)
            .filter(val => val.promotionId !== 'yell')
            .map('price.gross')
            .value()
        }
        bundlePriceAdjustment = _.concat([], bundlePriceAdjustment, yell, priceAdjustment)
      }

      // 配列を結合
      return _.concat([], item, bundle, bundlePriceAdjustment)
    },
    getPhysicalAdjustmentItems () {
      return _.chain(this.orderDetail)
        .thru(val => _.concat([], val.adjustmentItems))
        .filter(val => val.productId === this.getPhysicalProductId())
        .filter(val => val != null && val.delete !== 1)
        .map('price.gross')
        .value()
    },
    getOtherItems () {
      return _.chain(this.orderDetail)
        .thru(val => _.concat([], val.giftItems, val.shippingItems))
        .filter(val => val != null && val.delete !== 1)
        .flatMap(val => _.concat([], val, val.priceAdjustments))
        .filter(val => val != null && val.delete !== 1)
        .map('price.gross')
        .value()
    },
    getDigitalItems () {

      // 通常商品(バンドルではない)
      const item = _.chain(this.orderDetail)
        .thru(val => _.concat([], val.items))
        .filter(val => (val.isBundle === 0) && (val.bundleItems.length === 0))
        .filter(val => val.sku.productType === String(define.PRODUCT_TYPE.DIGITAL) || val.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_BONUS) || val.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_MESSAGE_BONUS))
        .filter(val => val != null && val.delete !== 1)
        .flatMap(val => _.concat([], val, val.priceAdjustments))
        .filter(val => val != null && val.delete !== 1)
        .map('price.gross')
        .value()

      // バンドル構成品
      const bundleItems = _.chain(this.orderDetail)
        .thru(val => _.concat([], val.items))
        .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
        .filter(val => val != null && val.delete !== 1)
        .flatMap(val => _.concat([], val.bundleItems))
        .filter(val => val.sku.productType === String(define.PRODUCT_TYPE.DIGITAL) || val.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_BONUS) || val.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_MESSAGE_BONUS))
        .filter(val => val != null && val.delete !== 1)
        .value()
      let bundle = []
      for (const item of bundleItems) {
        const grossPrice = _.chain(item)
          .thru(val => _.concat([], val.attributes))
          .filter((val) => val.attrId === 'base-gross-price')
          .map('attrValue')
          .value() * item.qty.current
        bundle = _.concat([], bundle, grossPrice)
      }

      // バンドル構成品の調整金額
      let bundlePriceAdjustment = []
      for (const i in this.orderDetail.items) {
        // バンドル構成品のフィジカル存在確認
        const bundlePhysical = _.chain(this.orderDetail)
          .thru(val => _.concat([], val.items[i]))
          .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
          .filter(val => (val.bundleItems.some((x) => {
            return (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.PHYSICAL_BONUS))
          })))
          .value()

        // バンドル構成品のデジタル存在確認
        const bundleDigital = _.chain(this.orderDetail)
          .thru(val => _.concat([], val.items[i]))
          .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
          .filter(val => (val.bundleItems.some((x) => {
            return (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_BONUS)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_MESSAGE_BONUS))
          })))
          .value()

        // バンドル構成品のフィジカル/デジタル種別チェック
        let productCategory
        if (bundlePhysical.length > 0 && bundleDigital.length > 0) {
          productCategory = PRODUCT_CATEGORY.MIXED
        } else if (bundleDigital.length > 0) {
          productCategory = PRODUCT_CATEGORY.DIGITAL
        } else { // (bundlePhysical.length > 0)
          productCategory = PRODUCT_CATEGORY.PHYSICAL
        }

        // バンドル構成品の調整金額(yell) ※混在の場合はデジタルに計上する
        let yell = []
        if (productCategory === PRODUCT_CATEGORY.DIGITAL || productCategory === PRODUCT_CATEGORY.MIXED) {
          yell = _.chain(this.orderDetail)
            .thru(val => _.concat([], val.items[i]))
            .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
            .filter(val => (val.bundleItems.some((x) => {
              return (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_BONUS)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_MESSAGE_BONUS))
            })))
            .filter(val => val != null && val.delete !== 1)
            .flatMap(val => _.concat([], val.priceAdjustments))
            .filter(val => val != null && val.delete !== 1)
            .filter(val => val.promotionId === 'yell')
            .map('price.gross')
            .value()
        }

        // バンドル構成品の調整金額 ※混在の場合はフィジカルに計上する
        let priceAdjustment = []
        if (productCategory === PRODUCT_CATEGORY.DIGITAL) {
          priceAdjustment = _.chain(this.orderDetail)
            .thru(val => _.concat([], val.items[i]))
            .filter(val => (val.isBundle === 1) && (val.bundleItems.length > 0))
            .filter(val => (val.bundleItems.some((x) => {
              return (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_BONUS)) || (x.sku.productType === String(define.PRODUCT_TYPE.DIGITAL_MESSAGE_BONUS))
            })))
            .filter(val => val != null && val.delete !== 1)
            .flatMap(val => _.concat([], val.priceAdjustments))
            .filter(val => val != null && val.delete !== 1)
            .filter(val => val.promotionId !== 'yell')
            .map('price.gross')
            .value()
        }
        bundlePriceAdjustment = _.concat([], bundlePriceAdjustment, yell, priceAdjustment)
      }

      // 配列を結合
      return _.concat([], item, bundle, bundlePriceAdjustment)
    },
    getDigitalAdjustmentItems () {
      return _.chain(this.orderDetail)
        .thru(val => _.concat([], val.adjustmentItems))
        .filter(val => val.productId === this.getDigitalProductId())
        .filter(val => val != null && val.delete !== 1)
        .map('price.gross')
        .value()
    },
    shipmentPhysicalTotal () {
      // 商品のフィジカルレコードチェック
      const physicalItems = this.getPhysicalItems()
      const physicalItemsGross = math.add(physicalItems)
      const isExistPhysicalItems = (physicalItems.length || 0) > 0

      // 注文調整金額按分のフィジカルレコードチェック
      const physicalAdjustmentItems = this.getPhysicalAdjustmentItems()
      const physicalAdjustmentItemsGross = math.add(physicalAdjustmentItems)

      // 商品のデジタルレコードチェック
      const digitalItems = this.getDigitalItems()
      const isExistDigitalItems = (digitalItems.length || 0) > 0

      // 送料等はフィジカル商品が１つ以上あれば、フィジカルに計上する
      let otherItemsGross = 0
      if (isExistPhysicalItems || !isExistDigitalItems) {
        const otherItems = this.getOtherItems()
        otherItemsGross = math.add(otherItems)
      }
      const gross = _.concat([], physicalItemsGross)
        .concat([], physicalAdjustmentItemsGross)
        .concat([], otherItemsGross)
      return math.add(gross)
    },
    shipmentDigitalTotal () {
      // 商品のデジタルレコードチェック
      const digitalItems = this.getDigitalItems()
      const digitalItemsGross = math.add(digitalItems)
      const isExistDigitalItems = (digitalItems.length || 0) > 0

      // 注文調整金額按分のデジタルレコードチェック
      const digitalAdjustmentItems = this.getDigitalAdjustmentItems()
      const digitalAdjustmentItemsGross = math.add(digitalAdjustmentItems)

      // 商品のフィジカルレコード存在チェック
      const physicalItems = this.getPhysicalItems()
      const isExistPhysicalItems = (physicalItems.length || 0) > 0

      // 送料等はフィジカル商品が１つもなければ、デジタルに計上する
      let otherItemsGross = 0
      if (!isExistPhysicalItems && isExistDigitalItems) {
        const otherItems = this.getOtherItems()
        otherItemsGross = math.add(otherItems)
      }
      const gross = _.concat([], digitalItemsGross)
        .concat([], digitalAdjustmentItemsGross)
        .concat([], otherItemsGross)
      return math.add(gross)
    }
  }
}
</script>
